import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import Base from "../../Config/Base";
import PDFIMG from "../../Config/pdf.svg";
import EXCELIMG from "../../Config/excel.svg";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Swal from "sweetalert2";
import { Footer } from "../footer/footer";

const Payments = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const [loading, setLoading] = useState(false);
  const [paymentsData, setPaymentsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_CRM_URL}payments/GetPayments`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setPaymentsData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setPaymentsData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    // If no search text, return all records
    if (!term) {
      return paymentsData;
    }

    return paymentsData.filter((item) => {
      return (
        item.paymentsModeName?.toLowerCase().includes(term) ||
        item.transactionid?.toLowerCase().includes(term) ||
        item.company_name?.toLowerCase().includes(term)
      );
    });
  }, [paymentsData, searchTerm]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleExcelDownload = () => {
    if (paymentsData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = paymentsData.map((item) => ({
      Payment: item.paymentsId,
      Invoice: `INV-2${item.invoiceId}`,
      "Payment Mode": item.paymentsModeName,
      "Transaction Id": item.transactionid,
      Customer: item.company_name,
      Amount: item.amount,
      Date: formatDate(item.date),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "paymentsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "paymentsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Leads Data",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Payment",
      "Invoice",
      "Payment Mode",
      "Transaction Id",
      "Customer",
      "Amount",
      "Date",
    ];
    tableData.push(headers);

    // Add rows
    paymentsData.forEach((item) => {
      const row = [];
      row.push(
        item.paymentsId,
        `INV-2${item.invoiceId}`,
        item.paymentsModeName,
        item.transactionid,
        item.company_name,
        item.amount,
        formatDate(item.date),
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("paymentsData.pdf");
  };

  const paid = Number(paymentsData?.amount || 0);
  const invoice = Number(paymentsData.InvoiceAmount || paymentsData.total || 0);
  const due = invoice - paid;
  const progress = invoice > 0 ? (paid / invoice) * 100 : 0;

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between ">
          <div className="page-title">
            <h4>Payments</h4>
            <h6>Manage your Payments</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  {/* <img src="assets/img/icons/pdf.svg" alt="PDF" /> */}
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
              <li>
                <Link
                  to="/AddPayment"
                  className="btn btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 my-2">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary" id="basic-addon1">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => {
            // Calculations
            const invoice = Number(item.invoiceAmount || 0);
            const paid = Number(item.amount || 0);
            const due = invoice - paid;
            const progress = invoice > 0 ? (paid / invoice) * 100 : 0;

            let statusText = "";
            let statusBg = "";
            let progressBarColor = "";
            let invoiceColor = "";

            if (paid <= 0) {
              statusText = "Unpaid";
              statusBg = "#FEE2E2";
              progressBarColor = "#EF4444"; // Red
              invoiceColor = "#EF4444"; // Red
            } else if (paid >= invoice) {
              statusText = "Paid";
              statusBg = "#D1FADF";
              progressBarColor = "#22C55E"; // Green
              invoiceColor = "#22C55E"; // Green
            } else {
              statusText = "Partially Paid";
              statusBg = "#FEF3C7";
              progressBarColor = "#F59E0B"; // Yellow
              invoiceColor = "#F59E0B"; // Yellow/Orange
            }
            return (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                {/* <div className="card mb-0 rounded-4">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <div className="d-flex align-items-center gap-1">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          background: "#1B2850",
                          color: "#fff",
                        }}
                      >
                        <i className="fa-solid fa-money-check-dollar fs-5"></i>
                      </div>

                      <Link
                        to={`/view-payment/${item.id}`}
                        className="text-decoration-none"
                      >
                        <h6
                          className="mb-0 fw-bold"
                          style={{ color: "#1B2850" }}
                        >
                          PAY-{item.id}
                        </h6>

                        <small className="text-danger">
                          INV-{item.InvoiceNumber}
                        </small>
                      </Link>
                    </div>

                    <div className="d-flex align-items-center gap-4">
                      <div className="text-start">
                        <div
                          className="fw-bold"
                          style={{
                            color: "#198754",
                            fontSize: "1.05rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <i className="fa-solid fa-indian-rupee-sign me-1"></i>

                          {Number(item.amount || 0).toLocaleString("en-IN")}
                        </div>
                      </div>
                      <div className="text-start">
                        <div className="d-flex align-items-center">
                          <span
                            className="badge  "
                            style={{
                              backgroundColor:
                                item.status === 0
                                  ? "#E9ECEF"
                                  : item.status === 1
                                  ? "#D1FADF"
                                  : item.status === 2
                                  ? "#FEF3C7"
                                  : item.status === 3
                                  ? "#FEE2E2"
                                  : "#F3F4F6",
                              color: "#1F2937",
                              borderRadius: "5px",
                            }}
                          >
                            {item.status === 0
                              ? "Draft"
                              : item.status === 1
                              ? "Paid"
                              : item.status === 2
                              ? "Partially Paid"
                              : item.status === 3
                              ? "Unpaid"
                              : "Unknown"}
                          </span>
                        </div>
                      </div>

                      
                      <div className="dropdown">
                        <a
                          href="/#"
                          className="text-dark"
                          onClick={(e) => e.preventDefault()}
                          data-bs-toggle="dropdown"
                        >
                          <i className="fa-solid fa-ellipsis-vertical fs-5"></i>
                        </a>

                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            to={`/view-payment/${item.id}`}
                            className="dropdown-item"
                          >
                            <i className="fa-regular fa-eye me-2"></i>
                            View
                          </Link>

                          <Link
                            to={`/edit-payment/${item.id}`}
                            className="dropdown-item"
                          >
                            <i className="fa-regular fa-pen-to-square text-info me-2"></i>
                            Edit
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row g-2">
                  
                    <div className="col-5">
                      <div className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-user me-2"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <span title={item.ClientName || "N/A"}>
                          {item.ClientName
                            ? item.ClientName.length > 15
                              ? item.ClientName.substring(0, 15) + "..."
                              : item.ClientName
                            : "N/A"}
                        </span>
                      </div>
                    </div>

                    <div className="col-5">
                      <div className="d-flex align-items-start">
                        <i
                          className="fa-solid fa-calendar-days me-2"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <span className="fw-medium">
                          {formatDate(item.date)}
                        </span>
                      </div>
                    </div>

                    <div className="col-2">
                      <div className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-credit-card me-2"
                          style={{ color: "#1B2850" }}
                        ></i>

                        <span title={item.PaymentModeName || "N/A"}>
                          {item.PaymentModeName
                            ? item.PaymentModeName.length > 12
                              ? item.PaymentModeName.substring(0, 12) + "..."
                              : item.PaymentModeName
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

                <div className="card border-0 shadow-sm rounded-4 mb-0">
                  <div className="card-body py-3 px-1">
                    <div className="row align-items-center g-2">
                      {/* Left - col-4 */}
                      <div className="col-4">
                        <div className="d-flex">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle text-white flex-shrink-0"
                            style={{
                              width: 34,
                              height: 34,
                              background: "#1B2850",
                              fontSize: 14,
                              fontWeight: 600,
                            }}
                          >
                            P
                          </div>

                          <div className="ms-2" style={{ minWidth: 0 }}>
                            <div className="d-flex align-items-center gap-1 flex-wrap">
                              <span
                                className="fw-bold"
                                style={{
                                  color: "#1B2850",
                                  fontSize: "13px",
                                }}
                              >
                                PAY-{item.id}
                              </span>

                              {/* <span
                                className="badge"
                                style={{
                                  background: statusBg,
                                  color: "#1F2937",
                                  fontSize: "9px",
                                  padding: "3px 6px",
                                  borderRadius: "5px",
                                  fontWeight: 500,
                                }}
                              >
                                {statusText}
                              </span> */}
                            </div>

                            <div
                              className="mt-1"
                              style={{
                                color: invoiceColor,
                                fontWeight: 600,
                                fontSize: "12px",
                              }}
                            >
                              INV-{item.InvoiceNumber}
                            </div>

                            <div
                              className="text-truncate"
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                maxWidth: "100%",
                              }}
                            >
                              <i className="fa-solid fa-user me-1"></i>
                              {item.ClientName || "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Center - col-3 */}
                      <div className="col-3 border-start">
                        <div
                          className="fw-bold text-success"
                          style={{ fontSize: "14px" }}
                        >
                          ₹{Number(item.amount || 0).toLocaleString("en-IN")}
                        </div>

                        <div className="mt-2" style={{ fontSize: "11px" }}>
                          <i className="fa-solid fa-calendar-days me-2"></i>
                          {formatDate(item.date)}
                        </div>

                        <div style={{ fontSize: "11px" }}>
                          <i className="fa-solid fa-credit-card me-2"></i>
                          {item.PaymentModeName || "N/A"}
                        </div>
                      </div>

                      {/* Right - col-4 */}
                      <div className="col-4 border-start">
                        <div
                          className="d-flex justify-content-between"
                          style={{ fontSize: "11px" }}
                        >
                          <span>Invoice</span>
                          <strong>₹{invoice.toLocaleString("en-IN")}</strong>
                        </div>

                        <div
                          className="d-flex justify-content-between mt-1"
                          style={{ fontSize: "11px" }}
                        >
                          <span className="text-success">Paid</span>
                          <strong className="text-success">
                            ₹{paid.toLocaleString("en-IN")}
                          </strong>
                        </div>

                        <div
                          className="progress my-2"
                          style={{ height: "5px" }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={statusText}
                        >
                          <div
                            className="progress-bar"
                            style={{
                              width: `${progress}%`,
                              backgroundColor: progressBarColor,
                            }}
                          ></div>
                        </div>

                        <div
                          className="d-flex justify-content-between"
                          style={{ fontSize: "11px" }}
                        >
                          <span style={{ color: "#E65C00" }}>Due</span>
                          <strong style={{ color: "#E65C00" }}>
                            ₹{due.toLocaleString("en-IN")}
                          </strong>
                        </div>
                      </div>

                      {/* Menu - col-1 */}
                      {due > 0 && (
                        <div className="col-1 text-center mb-5">
                          <div className="dropdown d-none">
                            <a
                              href="/#"
                              onClick={(e) => e.preventDefault()}
                              data-bs-toggle="dropdown"
                              className="text-dark"
                            >
                              <i className="fa-solid fa-ellipsis-vertical fs-lg"></i>
                            </a>

                            <div className="dropdown-menu dropdown-menu-end ">
                              <Link
                                // to={`/view-payment/${item.id}`}
                                className="dropdown-item"
                              >
                                <i className="fa-regular fa-credit-card me-2"></i>
                                Make As Payment
                              </Link>

                              <Link
                                // to={`/edit-payment/${item.id}`}
                                className="dropdown-item"
                              >
                                <i className="fa-regular fa-bell me-2 text-info"></i>
                                Reminder
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}

        <div className="col-12">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
      <Footer />
    </Base>
  );
};

export default Payments;
